/**
 * Created by prog2 on 26/10/2018.
 */
export default {
    images: [
        {
            id: 1,
            img: require('./../assets/img/art/1.jpg'),
            imageMenu: require('../assets/img/menu/thumb_1.png'),

        },
        {
            id: 2,
            img: require('./../assets/img/art/2.jpg'),
            imageMenu: require('./../assets/img/menu/thumb_2.png'),
        },
        {
            id: 3,
            img: require('./../assets/img/art/3.jpg'),
            imageMenu: require('./../assets/img/menu/thumb_3.png'),
        },
        {
            id: 4,
            imageMenu: require('./../assets/img/menu/thumb_4.png'),
            img: require('./../assets/img/art/4.jpg'),
        },
        {
            id: 5,
            imageMenu: require('./../assets/img/menu/thumb_5.png'),
            img: require('./../assets/img/art/5.jpg'),
        },
        {
            id: 6,
            imageMenu: require('./../assets/img/menu/thumb_6.png'),
            img: require('./../assets/img/art/6.jpg'),
        },
        {
            id: 7,
            imageMenu: require('./../assets/img/menu/thumb_7.png'),
            img: require('./../assets/img/art/7.jpg'),
        },
        {
            id: 8,
            imageMenu: require('./../assets/img/menu/thumb_8.png'),
            img: require('./../assets/img/art/8.jpg'),
        },
        {
            id: 9,
            imageMenu: require('./../assets/img/menu/thumb_9.png'),
            img: require('./../assets/img/art/9.jpg'),
        },
        {
            id: 10,
            imageMenu: require('./../assets/img/menu/thumb_10.png'),
            img: require('./../assets/img/art/10.jpg'),
        },
        {
            id: 11,
            imageMenu: require('./../assets/img/menu/thumb_11.png'),
            img: require('./../assets/img/art/11.jpg'),
        },
        {
            id: 12,
            imageMenu: require('./../assets/img/menu/thumb_12.png'),
            img: require('./../assets/img/art/12.jpg'),
        },
        {
            id: 13,
            imageMenu: require('./../assets/img/menu/thumb_13.png'),
            img: require('./../assets/img/art/13.jpg'),
        },
        {
            id: 14,
            imageMenu: require('./../assets/img/menu/thumb_14.png'),
            img: require('./../assets/img/art/14.jpg'),
        },
        {
            id: 15,
            imageMenu: require('./../assets/img/menu/thumb_15.png'),
            img: require('./../assets/img/art/15.jpg'),
        },
        {
            id: 16,
            imageMenu: require('./../assets/img/menu/thumb_16.png'),
            img: require('./../assets/img/art/16.jpg'),
        },
        {
            id: 17,
            imageMenu: require('./../assets/img/menu/thumb_17.png'),
            img: require('./../assets/img/art/17.jpg'),
        },
        {
            id: 18,
            imageMenu: require('./../assets/img/menu/thumb_18.png'),
            img: require('./../assets/img/art/18.jpg'),
        },
        {
            id: 19,
            imageMenu:require('./../assets/img/menu/thumb_19.png'),
            img: require('./../assets/img/art/19.jpg'),
        },
        {
            id: 20,
            imageMenu:require('./../assets/img/menu/thumb_20.png'),
            img: require('./../assets/img/art/20.jpg'),
        },
        {
            id: 21,
            imageMenu:require('./../assets/img/menu/thumb_21.png'),
            img: require('./../assets/img/art/21.jpg'),
        },
        {
            id: 22,
            imageMenu:require('./../assets/img/menu/thumb_22.png'),
            img: require('./../assets/img/art/22.jpg'),
        },
        {
            id: 23,
            imageMenu:require('./../assets/img/menu/thumb_23.png'),
            img: require('./../assets/img/art/23.jpg'),
        },
        {
            id: 24,
            imageMenu:require('./../assets/img/menu/thumb_24.png'),
            img: require('./../assets/img/art/24.jpg'),
        },
        {
            id: 25,
            imageMenu:require('./../assets/img/menu/thumb_25.png'),
            img: require('./../assets/img/art/25.jpg'),
        },
        {
            id: 26,
            imageMenu:require('./../assets/img/menu/thumb_26.png'),
            img: require('./../assets/img/art/26.jpg'),
        },
        {
            id: 27,
            imageMenu:require('./../assets/img/menu/thumb_27.png'),
            img: require('./../assets/img/art/27.jpg'),
        },
        {
            id: 28,
            imageMenu:require('./../assets/img/menu/thumb_28.png'),
            img: require('./../assets/img/art/28.jpg'),
        },
        {
            id: 29,
            imageMenu:require('./../assets/img/menu/thumb_29.png'),
            img: require('./../assets/img/art/29.jpg'),
        },
        {
            id: 30,
            imageMenu:require('./../assets/img/menu/thumb_30.png'),
            img: require('./../assets/img/art/30.jpg'),
        },
    ]
}



// WEBPACK FOOTER //
// ./src/data/images.js